import { render, staticRenderFns } from "./DotSelector.vue?vue&type=template&id=39f54be2&scoped=true&"
import script from "./DotSelector.vue?vue&type=script&lang=js&"
export * from "./DotSelector.vue?vue&type=script&lang=js&"
import style0 from "./DotSelector.vue?vue&type=style&index=0&id=39f54be2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f54be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f54be2')) {
      api.createRecord('39f54be2', component.options)
    } else {
      api.reload('39f54be2', component.options)
    }
    module.hot.accept("./DotSelector.vue?vue&type=template&id=39f54be2&scoped=true&", function () {
      api.rerender('39f54be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StationEvent/DotSelector.vue"
export default component.exports